<template>
  <v-container fluid class="pa-1 pa-sm-2">
    <v-row dense>
      <v-col
        v-for="(controllers, groupName) in dataset"
        :key="groupName"
        cols="12"
      >
        <v-card outlined>
          <v-card-title class="text-caption font-weight-bold py-1 px-2">
            {{ groupName }}
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-1">
            <v-row dense>
              <v-col
                v-for="controller in controllers"
                :key="controller.id"
                cols="12"
                sm="6"
                md="4"
                lg="3"
              >
                <v-card
                  outlined
                  :color="controller.active ? undefined : 'grey lighten-3'"
                  class="controller-card"
                  @click="copyHost(controller.host)"
                >
                  <v-card-text class="pa-2">
                    <div class="d-flex align-center">
                      <span
                        class="status-dot mr-2"
                        :class="{ active: controller.active }"
                      />
                      <span
                        class="text-body-2 text-truncate"
                        :class="
                          controller.active
                            ? 'grey--text text--darken-4'
                            : 'grey--text'
                        "
                      >
                        {{ controller.name }}
                      </span>
                    </div>

                    <div class="d-flex justify-space-between align-center mt-2">
                      <div class="d-flex align-center">
                        <template v-if="controller.gateways.length">
                          <v-tooltip
                            v-for="gateway in controller.gateways.slice(0, 6)"
                            :key="gateway.id"
                            bottom
                          >
                            <template #activator="{ on, attrs }">
                              <v-icon
                                v-if="gateway.type === 'door'"
                                v-bind="attrs"
                                v-on="on"
                                small
                                :color="
                                  gateway.active && controller.active
                                    ? 'green'
                                    : '#808080'
                                "
                              >
                                mdi-door
                              </v-icon>
                              <v-icon
                                v-else
                                v-bind="attrs"
                                v-on="on"
                                small
                                :color="
                                  gateway.active && controller.active
                                    ? 'green'
                                    : '#808080'
                                "
                              >
                                mdi-turnstile
                              </v-icon>
                            </template>
                            {{ gateway.name }}
                          </v-tooltip>
                          <span
                            v-if="controller.gateways.length > 6"
                            class="text-caption grey--text ml-1"
                          >
                            +{{ controller.gateways.length - 6 }}
                          </span>
                        </template>
                        <span v-else class="text-caption grey--text">—</span>
                      </div>

                      <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="text-caption grey--text text-no-wrap"
                          >
                            {{ formatRelativeTime(controller.modification) }}
                          </span>
                        </template>
                        {{
                          new Date(controller.modification).toLocaleString(
                            "ru-RU"
                          )
                        }}
                      </v-tooltip>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { groupBy, sortBy } from "lodash";
import { getControllers } from "../../services/device.service";
import { formatRelativeTime } from "../../utils/date-format";

export default {
  name: "ControllersStatistics",

  data: () => ({
    dataset: {},
    timer: null
  }),

  mounted() {
    this.getControllers();
    this.timer = setInterval(this.getControllers, 5 * 1000);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    async getControllers() {
      try {
        const controllers = await getControllers();
        this.dataset = groupBy(
          sortBy(
            controllers.map(c => ({
              ...c,
              gateways: c.gateways.length ? sortBy(c.gateways, ["name"]) : []
            })),
            c => [c.accessPoint?.name || c.typeName, c.name]
          ).reverse(),
          c => c.accessPoint?.name || c.typeName
        );
      } catch (e) {
        this.$notify({ text: e.response?.data?.message || e, type: "error" });
      }
    },

    formatRelativeTime,

    copyHost(host) {
      navigator.clipboard.writeText(host).then(
        () => this.$notify({ text: "Хост скопирован!", type: "success" }),
        () =>
          this.$notify({
            text: "Хост не может быть скопирован",
            type: "error"
          })
      );
    }
  }
};
</script>

<style scoped>
.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #808080;
  flex-shrink: 0;
}

.status-dot.active {
  background-color: transparent;
  border: 2px solid green;
}

.controller-card {
  cursor: pointer;
  transition: background-color 0.15s;
  height: 100%;
}

.controller-card:hover {
  background-color: rgba(0, 0, 0, 0.03);
}
</style>
